import EfScrollAni from '@/efscrollani';
import { useRouter } from 'next/router';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import D from './comps/D';
import E from './comps/E';
import F from './comps/F';
import FixTab from './comps/FixTab';
import G from './comps/G';
import H from './comps/H';
import TC from './comps/TC';
import css from './index.module.scss';
import { useProductPageStatus } from './ProductProvider';

const Page: React.FC = () => {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    const { locale = 'us' } = useRouter();
    const IS_EU = ['de', 'fr', 'it', 'es', 'uk', 'eu', 'nl'].includes(locale);
    const pageStatus = useProductPageStatus();

    const IS_JP_V2 = !['statusA', 'statusB'].includes(pageStatus) && locale === 'jp';
    const IS_NA = ['us', 'ca'].includes(locale);

    return (
        <div className={`${css.page} rapid-series`}>
            <A />
            <FixTab />

            {(IS_NA || IS_JP_V2) && <D />}
            <B />
            <C />
            {!IS_NA && !IS_JP_V2 && <D />}

            {IS_EU && <H endTime={new Date('2025/09/01 15:00:00 GMT+8').getTime()} />}
            <E />
            <G />
            <F />
            {IS_EU && <TC />}
        </div>
    );
};

export default Page;
